import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';

const StickyBookButton = () => {
  return (
    <div className="fixed bottom-5 right-5 z-40 lg:hidden">
      <Link
        to="/book"
        className="flex items-center justify-center gap-2 px-5 py-3.5 bg-[var(--text-primary)] text-[var(--bg-primary)] font-medium text-sm rounded-full shadow-lg hover:bg-[var(--interactive-hover)] transition-all active:scale-95"
        aria-label="Book appointment"
      >
        <Calendar size={18} />
        <span>Book Now</span>
      </Link>
    </div>
  );
};

export default StickyBookButton;
